import dayjs from "dayjs";

import { Issues } from "../gql/graphql";

import "dayjs/locale/pt-br";

dayjs.locale("pt-br");

export default function composeIssueTitle(issue: Pick<Issues, "name" | "yearMonth" | "isPreRelaunch">) {
  const safeName = issue.name ?? "Edição";
  
  if (issue.isPreRelaunch) {
    return safeName;
  }

  const formatted = issue.yearMonth ? dayjs(issue.yearMonth).format("MMMM [de] YYYY") : "";
  return formatted ? `Número ${safeName} (${formatted})` : `Número ${safeName}`;
}
